import React from 'react';
import Icon, { ICON_TYPE } from 'components/icon';

import AncestryPanel from './ancestry/ancestryPanel';
import FamilySearchPanel from './familysearch/familysearchPanel';
import ClassicPanel from './ancestry/classicPanel';
import CreationsPanel from './creations/creationsPanel';
import HolidaysPanel from './holidays/holidaysPanel';
import CustomEventPanel from './custom/customEventPanel';

const OPTIONS = {
  //
  // Ancestry
  //
  ancestry: {
    title: (
      <>
        <Icon className="text-ancestry" size={20} type={ICON_TYPE.ANCESTRY} />
        &nbsp;Ancestry
      </>
    ),
    Component: AncestryPanel,
  },

  //
  // FamilySearch
  //
  familysearch: {
    title: (
      <>
        <Icon className="text-familysearch" size={20} type={ICON_TYPE.FAMILY_SEARCH} />
        &nbsp;FamilySearch
      </>
    ),
    Component: FamilySearchPanel,
  },

  //
  // MyCanvas
  //
  mycanvas: {
    title: (
      <>
        <Icon className="text-primary" size={20} type={ICON_TYPE.FAMILY_SEARCH} />
        &nbsp;MyCanvas
      </>
    ),
    Component: AncestryPanel,
  },

  //
  // Previous Creations
  //
  creations: {
    title: 'Previous Creations',
    Component: CreationsPanel,
  },

  //
  // Holidays
  //
  holidays: {
    title: 'Holidays',
    Component: HolidaysPanel,
  },

  //
  // Custom Event
  //
  custom: {
    title: 'New Event',
    Component: CustomEventPanel,
  },

  //
  // MyCanvas Classic
  classic: {
    title: 'MyCanvas Classic',
    Component: ClassicPanel,
  },
};

export default OPTIONS;
